import './thesaurus-tree-node.scss'

import { defineComponent } from 'vue'
import {
    faCaretDown,
    faCaretRight
} from '@fortawesome/free-solid-svg-icons'

import { getTranslatedString, ThesaurusTermTreeNode } from '@skinsoft/types'
import { thesaurusTermSelectors } from '@skinsoft/selectors'
import { reactiveVueMixin } from "@skinsoft/reactive-vue"

export interface ThesaurusTreeNodeSelected {
    selectedThesaurusTermId: string
}

export const THESAURUS_TREE_NODE_SELECTED = 'thesaurus-tree-node-selected'
export const THESAURUS_TREE_NODE_OPENED = 'thesaurus-tree-node-opened'

// Recursive component: it references itself in its own `components` map so its template can
// recurse. A plain object literal can't self-reference in its own initializer (TDZ), so the
// self-entry is patched onto `components` right after the constant is created instead.
const ThesaurusTreeNode = defineComponent({
    mixins: [reactiveVueMixin],
    name: 's-thesaurus-tree-node',
    components: {},
    props: {
        thesaurusNode: {},
        selectedThesaurusTermId: {},
    },
    template: require('./thesaurus-tree-node.html'),
    data() {
        return {
            collapseIcon: faCaretRight,
            THESAURUS_TREE_NODE_SELECTED,
            THESAURUS_TREE_NODE_OPENED,
        }
    },
    computed: {
        termTitle() {
            return getTranslatedString(thesaurusTermSelectors.preferredTerm((this.thesaurusNode as ThesaurusTermTreeNode).term), this.getAppLocale())
        },
        termId() {
            return (this.thesaurusNode as ThesaurusTermTreeNode).term.id
        },
        isSelected() {
            return this.selectedThesaurusTermId === (this.thesaurusNode as ThesaurusTermTreeNode).term.id
        },
    },
    methods: {
        onTitleClicked() {
            this.$emit(THESAURUS_TREE_NODE_SELECTED, { selectedThesaurusTermId: (this.thesaurusNode as ThesaurusTermTreeNode).term.id } as ThesaurusTreeNodeSelected)
        },
        onCollapseIconClicked() {
            this.collapseIcon = this.collapseIcon === faCaretRight ? faCaretDown : faCaretRight
            if(this.collapseIcon === faCaretDown) {
                this.$emit(THESAURUS_TREE_NODE_OPENED, this.thesaurusNode)
            }
        },
    },
})

;(ThesaurusTreeNode as any).components.sThesaurusTreeNode = ThesaurusTreeNode

export default ThesaurusTreeNode
